module.exports = __webpack_public_path__ + "static/media/arrow.a2caf193.svg";